import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  changeDataSetting,
  changeParamsSetting,
  saveOnly,
  selectParamsSetting,
} from '../store/slice'
import { changeTypeCheckPort } from '../store/slicePortfolio'
import { getFilterDefault, getTotalCompanyBySettings } from '../store/thunk'
import { useCallApi } from '../useCallApi'
import { FilterDisplay } from './FilterDisplay'

const FilterCompanyDisplay = ({
  filterType,
  onClickFilter,
  isDisableApi,
  settingParamsWhenDisable,
}) => {
  const dispatch = useDispatch()

  const { isLoadingPort } = useCallApi()
  const settingParams = useSelector(selectParamsSetting)

  useEffect(() => {
    if (isLoadingPort) return
    if (Object.keys(settingParams).length === 0) {
      if (isDisableApi) {
        dispatch(changeParamsSetting(settingParamsWhenDisable))
        dispatch(changeDataSetting(settingParamsWhenDisable))
        dispatch(changeTypeCheckPort(false))
        dispatch(saveOnly(true))
      } else {
        dispatch(getFilterDefault({ FilterType: filterType }))
      }
    }
  }, [JSON.stringify(settingParams), isLoadingPort])

  useEffect(() => {
    if (Object.keys(settingParams).length !== 0) {
      dispatch(getTotalCompanyBySettings(settingParams))
    }
  }, [JSON.stringify(settingParams)])

  return <FilterDisplay filterType={filterType} onClickFilter={onClickFilter} />
}

FilterCompanyDisplay.propTypes = {
  filterType: PropTypes.string,
  onClickFilter: PropTypes.func,
  isDisableApi: PropTypes.bool,
  settingParamsWhenDisable: PropTypes.object,
}

FilterCompanyDisplay.defaultProps = {
  filterType: 'Library', //FILTER_TYPE.LIBRARY,
  onClickFilter: () => {},
  isDisableApi: false,
  settingParamsWhenDisable: {},
}

export default FilterCompanyDisplay
